import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectLabelValue } from 'src/app/models/select-label-value';
import { BoatService } from 'src/app/services/boat.service';
import { SlingLogService } from 'src/app/services/sling-log.service';
import { UserService } from 'src/app/services/user.service';
import { StorageUtil } from 'src/app/utils/storage.util';

@Component({
  selector: 'app-sling-log',
  templateUrl: './sling-log.component.html',
  styleUrls: ['./sling-log.component.scss']
})
export class SlingLogComponent implements OnInit {

  slingLogs = [];
  filteredUsers = [];
  boatsFilter: SelectLabelValue[] = [];
  filter = { marinaId: 0, dateStart: new Date(), dateEnd: new Date(), userId: null, boatId: null };

  pt = {
    firstDayOfWeek: 0,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
      'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };

  constructor(
    private slingLogService: SlingLogService,
    private userService: UserService,
    private boatService: BoatService,
    private spinner: NgxSpinnerService,
  ) { }

  async ngOnInit(): Promise<void> {
    const marina = StorageUtil.getMarina();
    this.filter.marinaId = marina.id;
    this.loadUsers();
    this.loadBoat();
    this.spinner.show();
    await this.find();
    this.spinner.hide();
  }

  async find(): Promise<void> {
    return new Promise<void>(async resolve => {
      this.slingLogService.findSlings(this.filter).subscribe(
        async (data) => {
          this.slingLogs = data;
          resolve();
        },
        async (error) => {
          console.error(error);
          resolve();
        }
      );
    });
  }

  loadBoat(): void {
    this.boatService.getAllByActiveForSelect().subscribe(
      (data) => {
        this.boatsFilter = data;
        this.boatsFilter.unshift({ label: 'Todos', value: null });
      }
    );
  }

  private loadUsers(): void {
    this.userService.getMarinaUsers().subscribe(
      (data) => {
        this.filteredUsers = data.map((c) => ({ label: c.firstName.concat(' ').concat(c.lastName), value: c.id }));
        this.filteredUsers.unshift({ label: 'Todos', value: null });
      }
    );
  }

}
